import React from 'react';
const links = [{
  label: 'Política de privacidad',
  href: '#privacidad'
}, {
  label: 'Términos del servicio',
  href: '#terminos'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function SiteFooter() {
  return <footer className="border-t border-line bg-cream" data-id="element-207" data-mp="3mg84lwl1nkv5">
      <div className="mx-auto max-w-6xl px-5 py-14" data-id="element-208" data-mp="3hiptbzjk0tjz">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr]" data-id="element-209" data-mp="3hhwtzjmxd6bv">
          <div data-id="element-210" data-mp="3dh4kcpa54zf2">
            <p className="font-display text-2xl font-semibold text-ink" data-id="element-211" data-mp="3dhmffil2h7le">El Profe de Guitarra</p>
            <p className="mt-3 max-w-prose text-[15px] leading-relaxed text-ink-soft" data-id="element-212" data-mp="38gqffg3u65l9">
              El sistema completo «Imprimí y enseñá» para profes de piano y guitarra.
            </p>
            <p className="mt-3 max-w-prose text-[13px] italic text-ink-mute" data-id="element-213" data-mp="2ykdga2piuzj4">
              Porque enseñar música no debería costarte todos los domingos del año.
            </p>
          </div>

          <nav aria-label="Enlaces legales" className="lg:justify-self-end" data-id="element-214" data-mp="wrz65pt7yzd9">
            <ul className="flex flex-col gap-3 text-sm text-ink-soft sm:flex-row sm:gap-8 lg:flex-col lg:gap-3 lg:text-right" data-id="element-215" data-mp="15r50iu5uh2o2">
              {links.map(link => <li key={link.label} data-id="element-216" data-mp="1anvenby39o6u">
                  <a href={link.href} className="transition-colors duration-150 ease-out hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-217" data-mp="vt7dg9zq1bx1">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <p className="mt-12 border-t border-line pt-6 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-218" data-mp="1erjndxygipto">
          © 2026 El Profe de Guitarra — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}